import * as z from "zod";
import { treatmentInputSchema } from "./create-automation-outreach-split";
import { automationOutreachSplitWithTreatmentsZodSchema } from "./get-automation-outreach-split";

export const updateAutomationOutreachSplit = {
  name: "updateAutomationOutreachSplit" as const,
  input: z.object({
    splitId: z.string(),
    name: z.string().optional(),
    description: z.string().optional(),
    treatments: z.array(treatmentInputSchema).optional(),
  }),
  output: automationOutreachSplitWithTreatmentsZodSchema,
};
